<template>
    <div class="content-wrapper">
      <section class="content-header">
        <h1>
          Journey: {{this.$route.query.journey_name}}
        </h1>
        <ol class="breadcrumb">
          <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
          <li> Scout JOR Mappings</li>
          <li><a href="scout_jor_list"> Mapping List</a></li>
          <li class="active">Mapping Detail</li>
        </ol>      
      </section>
      <section class="content">
        <div class="row" style="margin-top: 15px;">
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="form-group col-xs-12 col-sm-12 col-md-12">
              <div style="font-weight: bold">
                <button type="button" class="btn btn-primary btn-rounded btn-nudge" @click="addStageMapping"><i class="fa fa-plus" aria-hidden="true"></i></button> Add New Stage Mapping
              </div>
            </div>
          </div>
        </div>
        <div v-for="(item, index) in mappingList" :key="index">
          <div class="panel panel-default panel-group-container">
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12 col-lg-12 col-xs-12 keyword-conversation-container">
                  <div class="form-group col-xs-5 col-sm-5 col-md-5">
                    <label>Stage</label>
                    <nv-select class="form-control" id="stage" name="stage" v-model="item.stage">
                        <option value=null>--No Stage--</option>
                        <option v-for="(data, index) in stages" :key="index" :value="data">{{data}}</option>
                    </nv-select>
                  </div>
                  <div class="form-group col-xs-5 col-sm-5 col-md-5">
                    <label>Scout Menu</label>
                    <treeselect
                      placeholder="--Choose a conversation--"
                      :disabled="!!item.keyword_id" 
                      :multiple="false" 
                      :options="conversationList" 
                      v-model="item.content_id" />
                  </div>
                  <div class="form-group col-xs-2 col-sm-2 col-md-2">
                    <button type="button" class="btn btn-rounded btn-remove-nudge btn-nudge btn-primary col-xs-2 col-sm-2 col-md-2 col-2" style="margin-right: 5px;" @click="saveMapping(index)">
                      <i class="fa fa-save" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2" style="margin-right: 5px;" @click="removeMapping(index)">
                      <i class="fa fa-minus" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    <deleteConfirmationModal
      v-if="isDeleteConfirmationVisible"        
      @close="closeConfirmationModal" 
      @deleteMappingFromDB="deleteMappingFromDB"
      :isDeleteConfirmationVisible="isDeleteConfirmationVisible"
      :confirmationMessage="confirmationMessage" 
      :actionToBePerformed="actionToBePerformed"
    />
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
  import api from '../../../utils/api'
  import deleteConfirmationModal from './../popup/deleteConfirmation'

  export default {
    name: 'modal',
    components: {
      'deleteConfirmationModal': deleteConfirmationModal
    },
    data () {
      return {
        currentJourney: parseInt(this.$route.query.mappingId),
        mappingList: [{
          id: null,
          journey_id: parseInt(this.$route.query.mappingId),
          content_id: null,
          journey_name: null,
          stage: null
        }],
        conversationList: [],
        confirmationMessage: 'Are you sure you want to delete this Scout JOR mapping?',
        actionToBePerformed: 'Add Scout JOR mapping',
        isDeleteConfirmationVisible: false,
        rowIndexToBeUpdated: 0,
        loading: false,
        stages: []
      }
    },
    methods: {
      addStageMapping () {
        this.mappingList.push({
          id: null,
          journey_id: this.currentJourney,
          content_id: null,
          journey_name: null,
          stage: null
        })
      },
      async saveMapping (index) {
        const saveData = {
          id: this.mappingList[index].id,
          journey_id: this.mappingList[index].journey_id,
          content_id: this.mappingList[index].content_id,
          stage: this.mappingList[index].stage ? this.mappingList[index].stage.trim() : null
        }
        if (!saveData.journey_id) {
          this.$swal({
            type: 'error',
            text: 'Please Select Journey from listing page'
          })
          return
        }
        if (!saveData.content_id) {
          this.$swal({
            type: 'error',
            text: 'Please Select Scout Menu'
          })
          return
        }
        try {
          this.loading = true
          const saveResponse = await api.buildRequest('saveMapping', 'POST', saveData)
          if (saveResponse.data.payload.error && saveResponse.data.payload.error.message) {
            this.loading = false
            this.$swal({
              type: 'error',
              text: saveResponse.data.payload.error.message
            })
            return
          }
          if (saveResponse.status === 200) {
            if (!this.mappingList[index].id) {
              this.mappingList[index].id = saveResponse.data.payload.data.id
            }
            this.loading = false
            this.$swal({
              type: 'success',
              text: 'Mapping added successfully'
            })
          }
        } catch (error) {
          console.log('error: ', error)
          this.loading = false
          this.$swal({
            type: 'error',
            text: 'An error occurred'
          })
        }
      },
      removeMapping (index) {
        if (this.mappingList[index].id == null) {
          this.mappingList.splice(index, 1)
        } else {
          this.actionToBePerformed = 'Delete Scout JOR mapping stage'
          this.confirmationMessage = 'It will deleted mapping of all stages for this journey. Are you sure you want to delete this Scout JOR mapping?'
          this.isDeleteConfirmationVisible = true
          this.rowIndexToBeUpdated = index
        }
      },
      deleteMappingFromDB (index) {
        const removeData = this.mappingList[this.rowIndexToBeUpdated]
        this.loading = true
        var self = this
        api.buildRequest('deleteScoutJORMappingStage', 'POST', {id: removeData.id})
        .then(response => {
          self.loading = false
          if (response.status === 200) {
            self.isDeleteConfirmationVisible = false
            this.$swal({
              type: 'success',
              text: response ? response.data.payload.message : 'Scout JOR mapping deleted successfully'
            }).then(() => {
              self.mappingList.splice(self.rowIndexToBeUpdated, 1)
              self.rowIndexToBeUpdated = 0
            })
          } else {
            console.log('something went wrong')
          }
        }).catch(({ response }) => {
          self.rowIndexToBeUpdated = 0
          self.isDeleteConfirmationVisible = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      closeConfirmationModal () {
        this.isDeleteConfirmationVisible = false
      },
      async getConversationList () {
        try {
          this.loading = true
          const response = await api.buildRequest('getDeployedApps?type=CONVERSATION', 'GET', {})
          this.loading = false
          for (let app of response.data.payload) {
            this.conversationList.push({ id: app.id, label: app.appName })
          }
        } catch (error) {
          console.log('error: ', error)
          this.loading = false
        }
      },
      async getStages (mappingId) {
        try {
          this.loading = true
          const response = await api.buildRequest('get-states-by-id', 'POST', { journeyId: mappingId })
          const data = response.data.payload
          if (data.stages) {
            this.stages = data.stages
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          this.$swal({
            type: 'error',
            text: err.response ? err.response.data.payload.message : 'An error occurred'
          })
        }
      },
      async getMappingDetails (mappingId) {
        try {
          this.loading = true
          const response = await api.buildRequest('getScoutJORMappingDetails', 'POST', { journeyId: mappingId })
          const data = response.data.payload
          if (data.mappingDetails.length) {
            this.mappingList = data.mappingDetails
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          this.$swal({
            type: 'error',
            text: err.response ? err.response.data.payload.message : 'An error occurred'
          })
        }
      }
    },
    async mounted () {
      await this.getConversationList()
      if (this.$route && this.$route.query && this.$route.query.mappingId) {
        this.getMappingDetails(this.$route.query.mappingId)
        this.getStages(this.$route.query.mappingId)
      } else this.loading = false
    }
  }
</script>
<style>
.margin-left-20px {
  margin-left: 20px;
}
.form-group .padding-15px {
  padding: 0 15px;
}
</style>


// WEBPACK FOOTER //
// scoutJORMappingDetails.vue?42dc7e1a